module.exports = __webpack_public_path__ + "static/media/id.41c35788.svg";